module.exports = __webpack_public_path__ + "img/add-new.501b8d34.svg";